<template>
<!-- <transition name="info-card"> -->
  <div class="info-card-warp" :style="{'height': height || 'auto', 'width': width || '100%'}">
    
      <div class="info-card">
        <!-- 空内容时 -->
        <a-row v-if="!infoData.id" key="empty" class="empty-warp">
          <a-icon type="plus" />
        </a-row>
        
        <div v-else :key="infoData.id" class="detail-warp">
          <a-row type="flex" justify="space-between" align="middle" style="margin-bottom:5px">
            <img v-if="infoData.personPhotoUrl" class="person-img" :src="infoData.personPhotoUrl" alt="">
            <img v-else class="person-img" src="../../../assets/empty_person.png" alt="">

            <div style="text-align: center;">
              <div class="person-name">{{ infoData.targetName }}</div>
              <span 
                v-if="showDirection && infoData.outType === 1" 
                class="direction in"
              >{{$t('dashboard.infoEntryTxt')}}</span>
              <span 
                v-if="showDirection && infoData.outType === 2" 
                class="direction out"
              >{{$t('dashboard.infoExitTxt')}}</span>
            </div>

            <img v-if="infoData.scenePhotoUrl" class="person-img" :src="infoData.scenePhotoUrl" alt="">
            <!-- <img v-else class="person-img" src="../../../assets/logo.png" alt=""> -->
            <img v-else class="person-img" src="../../../assets/empty_person.png" alt="">
          </a-row>
          
          <a-row class="info-item" type="flex" justify="start" align="top">
            <div class="info-title" :style="{'text-align': showReason ? 'left' : 'right'}">{{$t('dashboard.infoChannelTxt')}}：</div>
            <div class="info-content" style="text-align: left">{{ infoData.deviceName }}</div>
          </a-row>

          <a-row class="info-item" type="flex" justify="start" align="top">
            <div class="info-title" :style="{'text-align': showReason ? 'left' : 'right'}">{{$t('dashboard.infoTimeTxt')}}：</div>
            <div class="info-content" style="text-align: left">{{ infoData.recognizeAt }}</div>
          </a-row>

          <a-row 
            class="info-item" type="flex" justify="start" align="top"
            v-if="showReason" 
          >
            <div class="info-title">{{$t('dashboard.infoVisitTxt')}}：</div>
            <div class="info-content text-area">{{ infoData.reason }}</div>
          </a-row>
        </div>
      </div>
    
  </div>
<!-- </transition> -->
</template>

<script>
export default {
  name: 'InfoCard',
  components: {},
  props: {
    width: {
      type: String
    },
    height: {
      type: String
    },
    marginTop: {
      type: String
    },

    showDirection: {
      type: Boolean,
      default: false
    },
    showReason: {
      type: Boolean,
      default: false
    },

    infoData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
  .info-card-warp{
    padding: 10px 5px 0 5px;
    display: inline-block;
  }

  .info-card-enter-active {
    transition: all 1s;
  }
  .info-card-enter {
    opacity: 0;
    transform: rotateX(180deg);
  }
  
  .info-card {
    background-image: url('../../../assets/dashboard/info_card.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
    clear: both;
    display: flex;

    .empty-warp{
      color: rgba(0,179,245,0.6);
      font-size: 32px;
      width: 100%;
      align-self: center;
      text-align: center;
    }
    .detail-warp{
      align-self: center;
      width: 100%;
      padding: 0 25px;
    }

    .person-img{
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    .person-name{
      height: 40px;
      width: 190px;
      background-image: url('../../../assets/dashboard/name_bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      letter-spacing: 2px;
      font-size: 15px;
      font-weight: bold;
      line-height: 40px;
      text-shadow: 0px 0px 5px #00fffc;
    }
    .direction{
      letter-spacing: 2px;
      font-weight: bold;
      position: relative;
      margin-left: 23px;
      margin-top: 5px;
      display: inline-block;
    }
    .direction:before{
      content: '';
      width: 40px;
      height: 40px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: absolute;
      top: -10px;
      left: -35px;
    }
    .direction.in{
      color: #10ff87;      
    }
    .direction.in:before{
      background-image: url('../../../assets/dashboard/icon_indoor.png');
    }
    .direction.out{
      color: #ff3a3a;      
    }
    .direction.out:before{
      background-image: url('../../../assets/dashboard/icon_outdoor.png');
    }

    .info-item{
      font-size: 12px;
      // margin: 5px 0;

      .info-title{
        width: 65px;
        letter-spacing: 1px;
        line-height: 22px;
      }
      .info-content{
        width: calc(100% - 65px);
        color: rgba(0,255,252,0.8);
        line-height: 22px;

        white-space: nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .info-content.text-area{
        height: 70px;
        border-radius: 4px;
        border: solid 1px rgba(0,179,245,0.3);
        background-color: rgba(2,67,91,0.3);
        padding: 2px 10px;

        white-space: unset;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
</style>
